import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { DeclarationSummary } from './DeclarationSummary';
import { useLanguage, getFinalJsonDataTranslation } from '../../hooks/useLanguage';

export const FinalJsonData = ({ jsonData }) => {
  const [isSummaryExpanded, setIsSummaryExpanded] = useState(false)
  const [isSpanish] = useLanguage();

  if (!jsonData) {
    return (
      <div className='mt-8 text-sm'>
        <div className="circle bg-default mb-2">
          <span className="text-white">3</span>
        </div>
        <div className='flex justify-between gap-4 mb-4 items-center'>
          <h1 className='text-3xl font-bold'>{getFinalJsonDataTranslation('reviewFinalJson', isSpanish)}</h1>
        </div>
        <div className="bg-gray-100 p-4 rounded-xl">
          <p>{getFinalJsonDataTranslation('waitingForData', isSpanish)}</p>
        </div>
      </div>
    );
  }

  return (
    <div className='mt-8 text-sm json-container' >
      <div className="circle bg-default mb-2">
        <span className="text-white">3</span>
      </div>
      <div className='flex justify-between gap-4 mb-4 items-center'>
        <h1 className='text-3xl font-bold'>{getFinalJsonDataTranslation('reviewFinalJson', isSpanish)}</h1>
      </div>
      <div className="mt-4">
        <pre className="bg-gray-100 p-4 rounded-xl overflow-auto max-h-[70vh]">
          {JSON.stringify(jsonData, null, 2)}
        </pre>
      </div>
    </div>
  );
};